var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{class:_vm.item.class || ''},[_c('router-link',{attrs:{"to":_vm.item.to || undefined}},[_vm._v("\n    "+_vm._s(_vm.item.value)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4cf9b4c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vuetify-form-creator/fields/vuetify-link.vue
// module id = 599
// module chunks = 0 1 2 3 4 5 6 7 8